import { motion } from "framer-motion";

const NODES = [
  { x: 300, y: 210, label: "Bremen", main: true },
  { x: 268, y: 138, label: "Bremen-Nord" },
  { x: 392, y: 178, label: "Achim" },
  { x: 196, y: 246, label: "Delmenhorst" },
  { x: 362, y: 288, label: "Syke" },
  { x: 348, y: 108, label: "Lilienthal" },
  { x: 440, y: 262, label: "Verden" },
];

export const RegionMap = () => (
  <div className="relative overflow-hidden rounded-[2.5rem] border border-[#17251C]/12 bg-[#DCCDB4]/45 p-4 md:p-8">
    <svg viewBox="0 0 600 380" className="w-full" role="img" aria-label="Einsatzgebiet Bremen und Umgebung">
      <defs>
        <pattern id="hgb-grid" width="26" height="26" patternUnits="userSpaceOnUse">
          <path d="M26 0H0v26" fill="none" stroke="rgba(47,61,46,0.12)" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="600" height="380" fill="url(#hgb-grid)" />

      <path
        d="M120 120c40-58 150-80 232-56 86 25 132 74 140 132 8 58-40 108-118 128-88 22-180 6-236-36-56-42-58-110-18-168Z"
        fill="rgba(147,163,135,0.3)"
        stroke="rgba(47,61,46,0.35)"
        strokeWidth="1.2"
      />
      <motion.path
        d="M150 300c60-30 80-70 150-92 62-20 90-58 160-78"
        fill="none"
        stroke="#B4623C"
        strokeWidth="2"
        strokeDasharray="5 9"
        initial={{ pathLength: 0 }}
        whileInView={{ pathLength: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 2.4, ease: "easeInOut" }}
      />

      {NODES.map((n, i) => (
        <g key={n.label}>
          {!n.main && (
            <motion.line
              x1="300"
              y1="210"
              x2={n.x}
              y2={n.y}
              stroke="rgba(47,61,46,0.3)"
              strokeWidth="1"
              strokeDasharray="3 5"
              initial={{ pathLength: 0 }}
              whileInView={{ pathLength: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.1, delay: 0.3 + i * 0.12 }}
            />
          )}
          <motion.circle
            cx={n.x}
            cy={n.y}
            r={n.main ? 8 : 4.5}
            fill={n.main ? "#17251C" : "#2F3D2E"}
            initial={{ scale: 0 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.35 + i * 0.1, type: "spring" }}
          />
          {n.main && (
            <motion.circle
              cx={n.x}
              cy={n.y}
              r="8"
              fill="none"
              stroke="#B4623C"
              strokeWidth="1.4"
              style={{ transformOrigin: `${n.x}px ${n.y}px` }}
              animate={{ scale: [1, 3.6], opacity: [0.7, 0] }}
              transition={{ duration: 2.8, repeat: Infinity, ease: "easeOut" }}
            />
          )}
          <text
            x={n.x + (n.main ? 15 : 9)}
            y={n.y + 4}
            fontSize={n.main ? 17 : 11.5}
            fontWeight={n.main ? 700 : 500}
            fill={n.main ? "#17251C" : "#4A5647"}
            fontFamily="Manrope, sans-serif"
            letterSpacing={n.main ? "0.04em" : "0"}
          >
            {n.label}
          </text>
        </g>
      ))}
    </svg>
  </div>
);
